import { render } from "./TTMBlockForm.vue?vue&type=template&id=211e9ee9"
import script from "./TTMBlockForm.vue?vue&type=script&setup=true&lang=js"
export * from "./TTMBlockForm.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/scada/forms/TTMBlockForm.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "211e9ee9"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('211e9ee9', __exports__)) {
    console.log('reload')
    api.reload('211e9ee9', __exports__)
  }
  
  module.hot.accept("./TTMBlockForm.vue?vue&type=template&id=211e9ee9", () => {
    console.log('re-render')
    api.rerender('211e9ee9', render)
  })

}


export default __exports__